import { render, staticRenderFns } from "./SearchProducts.vue?vue&type=template&id=a4133a6a&"
import script from "./SearchProducts.vue?vue&type=script&lang=js&"
export * from "./SearchProducts.vue?vue&type=script&lang=js&"
import style0 from "./SearchProducts.vue?vue&type=style&index=0&id=a4133a6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports